import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  selectBalance,
  selectIsCheckoutVisible,
  selectPrice,
  selectProductType,
  selectTotalAmount,
} from '../../../selectors/checkout';
import { Checkout as Checkout } from './Checkout';
import { SummaryItem } from './components/SummaryItem';
import { Total } from './components/Total';
import { getPriceTitle } from './utils';

export const CheckoutContainer = () => {
  const price = useSelector(selectPrice);
  const balance = useSelector(selectBalance);
  const totalAmount = useSelector(selectTotalAmount);
  const productType = useSelector(selectProductType);
  const isVisible = useSelector(selectIsCheckoutVisible);

  if (!isVisible) {
    return null;
  }

  const priceTitle = getPriceTitle(productType);

  return (
    <Checkout>
      <SummaryItem title={priceTitle}>{price}</SummaryItem>
      <SummaryItem title="Спишем с баланса">{balance}</SummaryItem>
      <Total>{totalAmount}</Total>
    </Checkout>
  );
};
